module.exports = __webpack_public_path__ + "static/media/4-1.a3df9390.webp";